import type { Caching } from "@/lib/caching"

export const cacheHasExpired = <DataType>(
  payload: Caching.Payload<DataType>,
  timestamp = Date.now()
): boolean => {
  const { cachedAt, expiresAt, expiry } = payload.caching

  if (expiresAt && expiresAt < timestamp) {
    return true
  }

  if (expiry && timestamp - cachedAt > expiry) {
    return true
  }

  return false
}
